__webpack_require__.p = "https://cdn.n-tv.de/sport/0.83.0/_next/";